import React, { useContext, useState,useEffect,useRef } from 'react';
import Header from './header';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';
import {
    Navigate,
    Link,
    NavLink,
    useNavigate,
    useParams
  } from "react-router-dom";
 import VisibilityIcon from '@mui/icons-material/Visibility';
  import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
  import { AppContext } from '../context';
  import { holdUser } from "../features/userdataSlice";
  import  secureLocalStorage  from  "react-secure-storage";

function Registration () {
    const { storage } = useContext(AppContext);
   
    const [showOrder, setShowOrder] = useState(false);
      const [userData, setuserData] = useState('');
    const dispatch = useDispatch();
    const [user, setUser] = useState({ parent_name: '', parent_email: '', create_pass: '',confirm_pass:'' });
    const [successMsg, setSuccessMsg] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [loader, setLoader] = useState(false);
    const [password, setPassword] = useState(true);
    const [displayPassword, setDisplayPassword] = useState('');
    const [displayPasswordCon, setDisplayPasswordCon] = useState('');
    const { dispatchStorageEvent } = useContext(AppContext);
    const [erroruserid, setErrorUserid] = useState(false);
    const [errorpassword, setErrorPassword] = useState(false);
     const [errorcontact, setErrorcontact] = useState(false);
        const [errorcreatepassword, setErrorCreatePassword] = useState(false);
    const [errorconfirmpassword, setErrorConfirmPassword] = useState(false);
    const [loginval, setloginval] = useState(0);
 const [loading, setLoading] = useState(false);
    const Axios = axios.create({
        baseURL: storage[0].backEndUrl
        // baseURL: process.env.REACT_APP_ENV_URL
    });
    let navigate = useNavigate();
   
    const [visible, setVisible] = useState(false);
   const [openLog, setOpenLog] = React.useState(false);
    const [passwordparent, setPasswordparent] = useState(true);
// password section code start
const [openEye, setOpenEye] = React.useState(false);
const handleClickOpenEye = () => {
    setPasswordparent(false);
    setOpenEye(true);
    
}
const handleClickCloseEye = () => {
    setPasswordparent(true);
    setOpenEye(false);
 
}

 const [openLogcon, setOpenLogcon] = React.useState(false);
    const [passwordparentcon, setPasswordparentcon] = useState(true);
// password section code start
const [openEyecon, setOpenEyecon] = React.useState(false);
const handleClickOpenEyecon = () => {
    setPasswordparentcon(false);
    setOpenEyecon(true);
    
}
const handleClickCloseEyecon = () => {
    setPasswordparentcon(true);
    setOpenEyecon(false);
 
}
    const logout = (e) => {
        secureLocalStorage.removeItem("username");
        secureLocalStorage.removeItem("userdata");
       
        dispatch(holdUser({}));
        navigate(`/`);
    
      }
      const timersRef = useRef([]); // Ref to store timers for each character

    React.useEffect(() => {

        if (document.body.classList.contains('body_bg')) {
          document.body.classList.remove('body');
    
        }
        document.body.classList.add('body_bg');
    var userid= secureLocalStorage.getItem('username');;

         console.log(JSON.parse(secureLocalStorage.getItem('userdata')));
        if(userid==null ){
 

          navigate(`/`);

        }else{
         setuserData(JSON.parse(secureLocalStorage.getItem('userdata')));
        }
      },[]);
const handleKeypress = e => {

        //it triggers by pressing the enter key
        if (e.which === 13) {
             e.preventDefault();
            handleSubmit();

        }
    };
    React.useEffect(() => {
        return cleanupTimers; // Cleanup on component unmount
    }, []);
    const changeUserData = (e) => {
        setErrorUserid(false);
        setErrorPassword(false);
        setErrorcontact(false);
        setErrorCreatePassword(false);
        setErrorConfirmPassword(false);
        var user_temp = { ...user };
        if (e.target.name == 'parent_name'){
            user_temp.parent_name = e.target.value;
            setUser(user_temp);
        }
        if (e.target.name == 'parent_email') {
            user_temp.parent_email = e.target.value;
            setUser(user_temp);
        }
       
        if (e.target.name == 'create_pass') {
            let curpassfin='';
            let lastsr= e.target.value;
            let str= e.target.value;
            if(lastsr.length==1 && lastsr.slice(-1)!='*'){
              user_temp.create_pass = e.target.value;
            //  alert(user_temp.create_pass);
            }else{
             
              if(lastsr.slice(-1).includes("*")){
               
                // alert(user_temp.create_pass);
                user_temp.create_pass =user_temp.create_pass.substring(0, user_temp.create_pass.length - 1);
               
              }else{
              //  alert(user_temp.create_pass);
              if(user_temp.create_pass!=''){
                user_temp.create_pass = user_temp.create_pass+lastsr.slice(-1);
              }else{
                user_temp.create_pass = e.target.value;
              //  
              }
              }
              if(e.target.value==''){
                user_temp.create_pass = '';
              }
              
            }
            
            setUser(user_temp);
            let curpass='';
            for (let i = 0; i < (str.length-1); i++) {
              curpass=curpass+'*';
            }
            
            for (let i = 0; i < (str.length); i++) {
              curpassfin=curpassfin+'*';
            }
           
            setDisplayPassword( curpass+lastsr.slice(-1));
             if(e.target.value!=''){
             
              const timer = setTimeout(() => {
                setDisplayPassword(prev => prev.slice(0, -1) + "*");
            }, 2000);
             // Store the timer in the ref array
          timersRef.current.push(timer);
           
             }
             
          
            
  
          
          }

          if (e.target.name == 'confirm_pass') {
            let curpassfin='';
            let lastsr= e.target.value;
            let str= e.target.value;
            if(lastsr.length==1 && lastsr.slice(-1)!='*'){
              user_temp.confirm_pass = e.target.value;
            //  alert(user_temp.confirm_pass);
            }else{
             
              if(lastsr.slice(-1).includes("*")){
               
                // alert(user_temp.confirm_pass);
                user_temp.confirm_pass =user_temp.confirm_pass.substring(0, user_temp.confirm_pass.length - 1);
               
              }else{
              //  alert(user_temp.confirm_pass);
              if(user_temp.confirm_pass!=''){
                user_temp.confirm_pass = user_temp.confirm_pass+lastsr.slice(-1);
              }else{
                user_temp.confirm_pass = e.target.value;
              //  
              }
              }
              if(e.target.value==''){
                user_temp.confirm_pass = '';
              }
              
            }
            
            setUser(user_temp);
            let curpass='';
            for (let i = 0; i < (str.length-1); i++) {
              curpass=curpass+'*';
            }
            
            for (let i = 0; i < (str.length); i++) {
              curpassfin=curpassfin+'*';
            }
           
            setDisplayPasswordCon( curpass+lastsr.slice(-1));
             if(e.target.value!=''){
             
              const timer = setTimeout(() => {
                setDisplayPasswordCon(prev => prev.slice(0, -1) + "*");
            }, 2000);
             // Store the timer in the ref array
          timersRef.current.push(timer);
           
             }
             
          
            
  
          
          }
        // if (e.target.name == 'parent_contact') user_temp.parent_contact = e.target.value;
      
    }

    const cleanupTimers = () => {
        timersRef.current.forEach(timer => clearTimeout(timer));
        timersRef.current = [];
    };
  
    const handleSubmit = (event) => {

        setErrorMsg('');
        setSuccessMsg('');
        setErrorUserid(false);
        setErrorPassword(false);
        setErrorcontact(false);
           setErrorCreatePassword(false);
        setErrorConfirmPassword(false);
        if (user.parent_name == '') { setErrorUserid(true); return false; }
        if (user.parent_email == '') { setErrorPassword(true); return false; }
          if (user.parent_contact == '') { setErrorcontact(true); return false; }
           if (user.create_pass == '') { setErrorCreatePassword(true); return false; }
          if (user.confirm_pass == '') { setErrorConfirmPassword(true); return false; }
          
           if (user.confirm_pass != user.create_pass) { setErrorMsg('Create and Confirm Password must be Same'); return false; }
        //    alert(user.create_pass);
        //    alert(user.confirm_pass);
        //    return false;
           setLoader(true);
        Axios.post(`/parent_details_edit`, { stuid: userData.stuid, parent_name: user.parent_name , parent_email: user.parent_email,password:btoa(user.create_pass)})
            .then(res => {
                console.log(res.data);

                if (res.data.status == true) {
                    console.log(res.data.data);
                    storage[0].userdata = res.data.data;
                    secureLocalStorage.setItem("userdata", JSON.stringify(res.data.data));
                    secureLocalStorage.setItem('username', userData.stuid);
                    secureLocalStorage.setItem('usernameotp', userData.stuid);
                    dispatchStorageEvent(storage);
                    setSuccessMsg('Registration Successfully!');

                    setLoader(false);
                    setloginval(2);





                }
                else {
                    setloginval(0);
                    setErrorMsg(res.data.message);
                    setLoader(false);
                }
            });
    }
      if (loginval == 2) {
        return <Navigate to='/otp' />;
    }
  return (
    <>
   <Header />

   <div className='regis-main-sec'>
        <div className='container'>
            <div className='row'>
                <div className='col-md-12'>
                    <div className='regis-head'>
                        <h2>REGISTRATION </h2>
                        <p>You only register once</p>
                    </div>
                </div>
            </div>

            <div className='regis-form-sec'>
                <div className='row'>
                    <div className='col-md-12'>
                    <div className='login-sec-page modl-login regis-top'>
                        <div className='login-secs login-secssss'>
                            <Box
                            component="form"
                            sx={{
                                '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                            }}
                            noValidate
                            autoComplete="off"
                            >

                            <TextField id="standard-basic" label="Parents/Guardian's Full Name" variant="outlined" className='required'
                                 value={user.parent_name} onChange={changeUserData} onKeyPress={handleKeypress}
                                                                name="parent_name"
                                                                error={erroruserid}
                helperText={` ${erroruserid == true ? 'Please enter Parents Full Name!' : ''}`} />
                            <span className='login-icon-regis'><PersonIcon /></span>
                            </Box>
                        </div>

                        <div className='login-secs login-emails login-secssss'>
                            <Box
                            component="form"
                            sx={{
                                '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                            }}
                            noValidate
                            autoComplete="off"
                            >

                            <TextField id="standard-basic" label="Email Id" variant="outlined"
                                                        value={user.parent_email}
                                                         onChange={changeUserData}
                                                          onKeyPress={handleKeypress}
                                                                name="parent_email"
                                                                error={errorpassword}
                helperText={` ${errorpassword == true ? 'Please enter Parents Email Id!' : ''}`} className="required" />
                            <span className='login-icon-regis'><EmailIcon /></span>
                          
                            </Box>
                           
                        </div>
                        <p className='veri-sec'><span>this email will be verified</span></p>

                        
                        <div className={`login-secs regis-email login-secssss ${displayPassword!='' && 'new-pass-ass'  }`}>
                            <Box
                            component="form"
                            sx={{
                                '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                            }}
                            noValidate
                            autoComplete="off"
                            >

                            <TextField id="standard-basic" label="Create Password" variant="outlined"
                                type={'text'} 
                                  onKeyPress={handleKeypress}
                  name="create_pass"
                  value={displayPassword} onChange={changeUserData}

                  error={errorcreatepassword}  placeholder=''

                  helperText={` ${errorcreatepassword == true ? 'Please enter Create Password!' : ''}`} className="required" />
                            <span className='login-icon-regis'><LockIcon /></span>

                            {/* <div className='psd-sec'>
                            <span className="visible-sec" onClick={handleClickOpenEye} style={{display: openEye ? "none" : "block" }}><VisibilityOffIcon /></span>
                            <span className="visible-sec" onClick={handleClickCloseEye} style={{display: openEye ? "block" : "none" }}><VisibilityIcon /></span>
                    </div> */}
                            </Box>
                        </div>

                        
                        <div className={`login-secs login-secssss ${displayPasswordCon!='' && 'new-pass-ass'  }`}>
                            <Box
                            component="form"
                            sx={{
                                '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                            }}
                            noValidate
                            autoComplete="off"
                            >

                            <TextField id="standard-basic" label="Confirm Password" variant="outlined"
                                type={ 'text'} 
                                  onKeyPress={handleKeypress}
                  name="confirm_pass"
                  value={displayPasswordCon} onChange={changeUserData}

                  error={errorconfirmpassword}  placeholder=''

                  helperText={` ${errorconfirmpassword == true ? 'Please enter Confirm Password!' : ''}`} className="required" />
                            <span className='login-icon-regis'><LockIcon /></span>
                             {/* <div className='psd-sec'>
                            <span className="visible-sec" onClick={handleClickOpenEyecon} style={{display: openEyecon ? "none" : "block" }}><VisibilityOffIcon /></span>
                            <span className="visible-sec" onClick={handleClickCloseEyecon} style={{display: openEyecon ? "block" : "none" }}><VisibilityIcon /></span>
                    </div> */}
                            </Box>
                        </div>

                        <div className='login-submit' style={{textAlign:'center'}}>
                           
                                <button className='btn btn-login btn-login-sumt btn-reg-submt' onClick={handleSubmit}>SUBMIT
                                {
                                                                        loader != '' ?
                                                                            <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff",position:'absolute',marginTop:'3px' }} />
                                                                            :  ''

                                                                    }</button>
                                                                    {
                                                                    loader != '' ? <div className="success-msg success-new-msg">
                                                                        <p className="success-msg">Please wait while we get you access to the system</p>

                                                                    </div> : 
                                                                    <div className="success-msg success-new-msg">
                                                                    <p className="success-msg" style={{ visibility: 'hidden' }} >Please wait while we fetch your data</p>
                                                                    </div>
                                                                }
                                                             
                                                                {
                                                                    successMsg != '' ? <div className="success-msg">
                                                                        <p className="success-msg">{successMsg}</p>
                                                                    </div> : ''
                                                                }


                                                                {
                                                                    errorMsg != '' ? <div className="error-msg" >
                                                                        <p className="error-msg">{errorMsg}</p>
                                                                    </div> : <div className="error-msg" style={{ visibility: 'hidden' }} >
                                                                        <p className="error-msg">Wrong credentials!</p>
                                                                    </div>
                                                                }
                            
                        </div>

                        </div>
                
                    </div>
                </div>
            </div>
        
        </div>

   </div>
   </>
  )
}

export default Registration;